import { useState, useEffect } from 'react';
import { PropertyCard } from '../components/PropertyCard';
import { FilterBar } from '../components/FilterBar';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function PropertiesPage() {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProperties = async (filters = {}) => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.listing_type) params.append('listing_type', filters.listing_type);
      if (filters.location) params.append('location', filters.location);
      if (filters.min_price) params.append('min_price', filters.min_price);
      if (filters.max_price) params.append('max_price', filters.max_price);

      const response = await axios.get(`${API}/properties?${params.toString()}`);
      setProperties(response.data);
    } catch (error) {
      toast.error('Erreur lors du chargement des biens');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProperties();
  }, []);

  return (
    <div data-testid="properties-page" className="min-h-screen pt-20 pb-24 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto space-y-12">
        <div className="pt-12 space-y-4">
          <h1 className="text-5xl md:text-6xl font-serif tracking-tight leading-none">Nos biens disponibles</h1>
          <p className="text-base md:text-lg leading-relaxed text-muted-foreground max-w-2xl">
            Découvrez notre sélection exclusive de propriétés en Belgique
          </p>
        </div>

        <FilterBar onFilter={fetchProperties} />

        {loading ? (
          <div data-testid="loading-spinner" className="text-center py-24">
            <div className="text-lg text-muted-foreground">Chargement...</div>
          </div>
        ) : properties.length === 0 ? (
          <div data-testid="no-properties" className="text-center py-24">
            <div className="text-lg text-muted-foreground">Aucun bien disponible</div>
          </div>
        ) : (
          <div data-testid="properties-grid" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
            {properties.map((property) => (
              <PropertyCard key={property.id} property={property} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PropertiesPage;